import { put, select, fork, join, takeEvery, takeLeading, call } from "redux-saga/effects";
import apiClient from "utils/apiClient";
import * as API from "containers/APIurls";
import * as GlobalSlice from "./GlobalSlice";
import * as QualificationSlice from "../../pages/Qualification/ducks/QualificationSlice";
import Utils from 'app/ducks/utils'

function* showLoading(data) {
  yield put(GlobalSlice.setLoading(true));
}

function* hideLoading(data) {
  yield put(GlobalSlice.setLoading(false));
}

function* showStickyHeaderValues(data) {
  yield put(GlobalSlice.setShowStickyHeaderValues(true));
}

function* hideStickyHeaderValues(data) {
  yield put(GlobalSlice.setShowStickyHeaderValues(false));
}

function* changeFlow(data) {
  const flow = GlobalSlice.getFlow(data.payload);
  yield put(GlobalSlice.setFlow(flow));
}

function* showNotification(data) {
  const { payload } = data;
  yield put(GlobalSlice.setNotification({ title: payload.title || "Please Provide Title", subtitle: payload.subtitle, closable: payload.closable || true, type: payload.type || "warning", open: true }));
}

function* hideNotification() {
  yield put(GlobalSlice.setNotification({ open: false }));
}

export function* initializeMfe() {
  yield put(GlobalSlice.setApiError(false));
  try {
    const widgetInputParams = yield select(state => state.ProspectWidgets_GlobalData?.widgetInputParams);
    const payload = {
      shoppingPath: window?.mbtGlobal?.shoppingPath,
      mfeShoppingPath: window?.mbtGlobal?.shoppingPath,
      clientId: widgetInputParams?.clientName?.value ?? window?.mbtGlobal?.clientId ?? "MBT",
      sourceSystem: widgetInputParams?.sourcesystem?.value ?? widgetInputParams?.target?.value ?? window?.mbtGlobal?.sourceSystem ?? "",
      ecpdId: window?.mbtGlobal?.ecpdId ?? widgetInputParams?.ecpdId?.value,
      loginUserId: window?.mbtGlobal?.userId ?? widgetInputParams?.mbLoginId?.value ?? widgetInputParams?.loginUserId?.value ?? widgetInputParams?.mbaUserId?.value ?? window?.mbtGlobal?.userId,
      userId: window?.mbtGlobal?.userId ?? widgetInputParams?.mbLoginId?.value ?? widgetInputParams?.loginUserId?.value ?? widgetInputParams?.mbaUserId?.value ?? window?.mbtGlobal?.userId,
      rootEcpdId: window?.mbtGlobal?.rootEcpdProfileId ?? widgetInputParams?.ecpdId?.value ?? "",
      userEmail: window?.mbtGlobal?.userEmail ?? widgetInputParams?.mbaUserEmail?.value ?? "",
      companyName: window?.mbtGlobal?.companyName ?? widgetInputParams?.companyName?.value ?? "",
      channel: widgetInputParams?.clientName?.value ?? "",
      csr: window?.mbtGlobal?.isCSR ?? "",
      csrRole: window?.mbtGlobal?.csrRole ?? "",
      csrId: window?.mbtGlobal?.csrId ?? "",
      csrFirstName: window?.mbtGlobal?.csrFirstName ?? "",
      csrLastName: window?.mbtGlobal?.csrLastName ?? "",
      csrEmail: window?.mbtGlobal?.csrEmail ?? "",
      csrRoleEligibleForCommerceOrdering: window?.mbtGlobal?.csrRoleEligibleForCommerceOrdering ?? "",
      userRole: window?.mbtGlobal?.userRole,
      zipCode: window?.mbtGlobal?.defaultBusinessZipCode ?? widgetInputParams?.zipCode?.value ?? widgetInputParams?.zipCode?.value ?? "30004"
    }
    const response = yield apiClient.post(API.INITIALIZE_MFE_URL, payload);
    if (response?.status === 200 && !!response?.data && (response?.data?.serviceStatus?.success)) {
      yield put(GlobalSlice.setInitializeMfeResponse(response?.data));
      if (response?.data?.userSavedAddressInfo) {
        yield put(QualificationSlice.setSavedAddressDetails(response?.data?.userSavedAddressInfo));
      }
    }
  } catch (err) {
    yield put(GlobalSlice.setApiError(true));
  } finally {
  }
}

export function* getMetaInformation() {
  yield put(GlobalSlice.setApiError(false));
  yield showLoading();
  try {
    const flow = yield select(state => state.ProspectWidgets_GlobalData.flow);
    const requestBody = {
      digitalQuote: false,
      shoppingPath: "PROSPECT",
      approach: "",
      flow,
    };
    const resp = yield apiClient.post(
      API.DEVICE_META_INFORMATION_URL,
      requestBody);
    let meta = resp?.data;
    const metaData = { ...resp?.data?.data };
    delete meta["data"];
    delete meta["serviceStatus"];
    meta = { ...meta, ...metaData };
    yield put(GlobalSlice.setMetaInfo(meta));
  } catch (err) {
    yield put(GlobalSlice.setApiError(true));
  } finally {
    yield hideLoading();
  }
}

export function* getSessionCartData(payload) {
  try {
    const flow = yield select(state => state.ProspectWidgets_LQPage.flow);
    const checkoutData = yield select(
      (state) => state.ProspectWidgets_CheckoutData
    );
    let currentSectionName;
    if (checkoutData) {
      if (
        checkoutData?.activeAccordian ===
        checkoutData?.activeAccordionDisplayOrder?.creditResult
      ) {
        currentSectionName = "credit-result";
      } else if (
        checkoutData?.activeAccordian ===
        checkoutData?.activeAccordionDisplayOrder?.reviewOrder
      ) {
        currentSectionName = "review";
      } else if (
        checkoutData?.activeAccordian ===
        checkoutData?.activeAccordionDisplayOrder?.maa
      ) {
        currentSectionName = "agreement";
      } else if (
        checkoutData?.activeAccordian ===
        checkoutData?.activeAccordionDisplayOrder?.shipping
      ) {
        currentSectionName = "shipping";
      }
    }
    const requestBody = {
      cartMeta: {
        sourcePath: "CART"
      },
      shoppingPath: flow,
      approach: payload?.payload?.approach ?? "",
      flow,
      currentSectionName: currentSectionName
    }
    const response = yield apiClient.post(API.CARTCOMP_SESSION_CART_URL, requestBody);
    if (response && response.data && response.data.prospectFlowData) {
      const storebeforePackage = response.data.prospectFlowData;
      window?.localStorage?.setItem('_zipCodeFromSession', storebeforePackage?.businessInfo?.address?.zipCode);
      const newStore = Utils.setStoreFromRetrieve(response.data);
      yield put(GlobalSlice.setSessionCartData(newStore));
      window?.localStorage?.setItem('_cartData', JSON.stringify(newStore));
    }
  } catch (err) {
    // error
    yield put(GlobalSlice.setApiError(true));
  }
}

function* getSessionCart(payload) {
  yield showLoading();
  try {
    yield call(getSessionCartData, payload);
  } catch (err) {
    yield put(GlobalSlice.setApiError(true));
  } finally {
    yield hideLoading();
  }
}

function* getGlobalPageLoadData({ payload }) {
  yield put(GlobalSlice.setApiError(false));
  yield showLoading();
  try {
    const { sessionCart, metaInformation, clear4g5gcart: isClearCart } = payload || {};
    const forks = [];
    if (metaInformation) {
      forks.push(yield fork(getMetaInformation));
    }
    if (sessionCart) {
      forks.push(yield fork(getSessionCartData));
    }
    yield join([...forks]);
  } catch (err) {
    console.error(err)
    yield put(GlobalSlice.setApiError(true));
  } finally {
    yield hideLoading();
  }
}

function* getCombinePricing() {
  yield put(GlobalSlice.setApiError(false));
  yield showLoading();
  try {
    const requestBody = {
      cartMeta: { initFlow: true },
      shoppingPath: "PROSPECT",
      approach: "",
      flow: "one-talk",
    };
    const resp = yield apiClient.post(API.CARTCOMP_ONETALK_COMBINE_PRICING_URL, requestBody);
    yield put(GlobalSlice.setCombinePricingInfo(resp?.data?.response));
  } catch (err) {
    console.error(err)
    yield put(GlobalSlice.setApiError(true));
  } finally {
    yield hideLoading();
  }
}

function* postSaveCart(params) {
  yield showLoading();
  const requestBody = params?.payload;
  try {
    const response = yield apiClient.post(API.CARTCOMP_CART_SAVE_URL, requestBody);
    if (response) {
      yield put(GlobalSlice.setSaveCartSuccess(response));
      yield put(GlobalSlice.setCartId(response?.data?.cartId));
      if (response?.data?.cpqCartVersionId) {
        yield put(GlobalSlice.setCartVersionId(response?.data?.cpqCartVersionId));
      }
    }
  } catch (err) {
    // error handling
  } finally {
    yield hideLoading();
  }
}

function* callAddressValidation(params) {
  yield put(GlobalSlice.setApiError(false));
  yield showLoading();
  try {
    const data = params.payload;
    let requestBody = {
      address: {
        addressLine1: data?.addressLine1,
        city: data?.city,
        state: data?.state,
        zipCode: data?.zipCode,
        addressLine2: data?.addressLine2,
      },
    };
    const response = yield apiClient.post(
      API.ADDRESS_VALIDATION_URL,
      requestBody
    );
    yield put(GlobalSlice.setAddressValidation(response.data));
  } catch (err) {
    console.error(err);
    yield put(GlobalSlice.setApiError(true));
  } finally {
    yield hideLoading();
  }
}

export default function* actionWatcher() {
  yield takeEvery(GlobalSlice.showLoading.type, showLoading);
  yield takeEvery(GlobalSlice.hideLoading.type, hideLoading);
  yield takeEvery(GlobalSlice.showStickyHeaderValues.type, showStickyHeaderValues);
  yield takeEvery(GlobalSlice.hideStickyHeaderValues.type, hideStickyHeaderValues);
  yield takeEvery(GlobalSlice.changeFlow.type, changeFlow);
  yield takeEvery(GlobalSlice.showNotification.type, showNotification);
  yield takeEvery(GlobalSlice.hideNotification.type, hideNotification);
  yield takeLeading(GlobalSlice.initializeMfe.type, initializeMfe);
  yield takeLeading(GlobalSlice.getMetaInformation.type, getMetaInformation);
  yield takeLeading(GlobalSlice.getSessionCart.type, getSessionCart);
  yield takeLeading(GlobalSlice.getGlobalPageLoadData.type, getGlobalPageLoadData);
  yield takeLeading(GlobalSlice.getCombinePricing.type, getCombinePricing);
  yield takeLeading(GlobalSlice.postSaveCart.type, postSaveCart);
  yield takeLeading(GlobalSlice.callAddressValidation.type, callAddressValidation);
}
